function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isPlainObject from 'lodash.isplainobject';

var formatSizeAndUnits = function formatSizeAndUnits(_ref) {
  var size = _ref.size,
      units = _ref.units;
  var formattedSize;
  var formattedUnits;

  if (size < 1e+3) {
    formattedSize = size;
    formattedUnits = units.byte;
  } else if (size >= 1e+3 && size < 1e+6) {
    formattedSize = (size / 1e+3).toFixed(2);
    formattedUnits = units.kilobyte;
  } else if (size >= 1e+6 && size < 1e+9) {
    formattedSize = (size / 1e+6).toFixed(2);
    formattedUnits = units.megabyte;
  } else if (size >= 1e+9 && size < 1e+12) {
    formattedSize = (size / 1e+9).toFixed(2);
    formattedUnits = units.gigabyte;
  } else {
    formattedSize = (size / 1e+12).toFixed(2);
    formattedUnits = units.terabyte;
  }

  return {
    size: formattedSize,
    units: formattedUnits
  };
};

var areUnitsEqual = function areUnitsEqual(units1, units2) {
  var keys1 = Object.keys(units1);

  if (keys1.length === Object.keys(units2).length) {
    return keys1.every(function (key1) {
      return units1[key1] === units2[key1];
    });
  }

  return false;
};

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    units: {
      type: Object,
      validator: function validator(value) {
        var obj = {
          byte: 'string',
          kilobyte: 'string',
          megabyte: 'string',
          gigabyte: 'string',
          terabyte: 'string'
        };

        if (!isPlainObject(value)) {
          return false;
        }

        var keys = Object.keys(obj);
        var valueKeys = Object.keys(value);
        return valueKeys.every(function (key) {
          if (keys.indexOf(key) === -1) {
            return false;
          }

          return _typeof(value[key]) === obj[key];
        });
      },
      default: function _default() {
        return Object({
          byte: 'B',
          kilobyte: 'KB',
          megabyte: 'MB',
          gigabyte: 'GB',
          terabyte: 'TB'
        });
      }
    },
    uploader: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      state: {
        size: this.uploader.methods.getSize(this.id)
      }
    };
  },
  computed: {
    formatted: function formatted() {
      return formatSizeAndUnits({
        size: this.state.size,
        units: this.units
      });
    }
  },
  created: function created() {
    var _this = this;

    var scalingOption = this.uploader.options.scaling;

    if (scalingOption && scalingOption.sizes.length) {
      // If this is a scaled image, the size won't be known until upload time.
      this._onUploadHandler = function (id) {
        if (id === _this.id) {
          _this.$set(_this.state, 'size', _this.uploader.methods.getSize(id));
        }
      };
    }
  },
  mounted: function mounted() {
    this._onUploadHandler && this.uploader.on('upload', this._onUploadHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this._onUploadHandler && this.uploader.off('upload', this._onUploadHandler);
  },
  beforeUpdate: function beforeUpdate(nextProps, nextState) {
    return nextState.size !== this.state.size || !areUnitsEqual(nextProps.units, this.units);
  }
};